export default __webpack_public_path__ + "static/media/7c26f795fb2dfe25680b68d243760045.svg";